import { Mail, Phone, Instagram } from "lucide-react";
import { CONTACT } from "@/constants/testIds";
import { WEDDING } from "@/data/wedding";
import { useLang } from "@/i18n/LanguageContext";
import { DahliaFlourish } from "@/components/wedding/Flourish";

export const Contact = () => {
  const { t } = useLang();
  const heading = t("contact.heading");

  return (
    <section id="contact" data-testid={CONTACT.section} className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] sunset-orb opacity-40 pointer-events-none" aria-hidden />
      <DahliaFlourish
        className="absolute -top-6 -left-10 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.85}
      />
      <DahliaFlourish
        className="absolute -bottom-8 -right-10 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.85}
      />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <h2 className="mt-4 font-display text-5xl sm:text-7xl lg:text-8xl tracking-tighter font-light leading-[0.95]">
          {heading[0]}<em className="italic">{heading[1]}</em>{heading[2]}
        </h2>
        <p className="mt-8 font-serif italic text-xl text-black/65 max-w-2xl mx-auto">{t("contact.sub")}</p>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-px bg-black/10 border border-black/10">
          <a
            href="mailto:carmen.kerbert@gmail.com"
            data-testid={CONTACT.email}
            className="group bg-white p-10 hover:bg-black hover:text-white transition-colors flex flex-col items-center gap-3"
          >
            <Mail size={20} className="text-[color:var(--sunset-500)] group-hover:text-[color:var(--sunset-300)]" />
            <div className="font-overline text-[10px] opacity-60">{t("contact.emailLabel")}</div>
            <div className="font-serif text-xl italic">carmen.kerbert@gmail.com</div>
          </a>
          <a
            href="tel:+37253618931"
            data-testid={CONTACT.phone}
            className="group bg-white p-10 hover:bg-black hover:text-white transition-colors flex flex-col items-center gap-3"
          >
            <Phone size={20} className="text-[color:var(--sunset-500)] group-hover:text-[color:var(--sunset-300)]" />
            <div className="font-overline text-[10px] opacity-60">{t("contact.phoneLabel")}</div>
            <div className="font-serif text-xl italic">+372 5361 8931</div>
          </a>
          <a
            href="#"
            className="group bg-white p-10 hover:bg-black hover:text-white transition-colors flex flex-col items-center gap-3"
          >
            <Instagram size={20} className="text-[color:var(--sunset-500)] group-hover:text-[color:var(--sunset-300)]" />
            <div className="font-overline text-[10px] opacity-60">{t("contact.followLabel")}</div>
            <div className="font-serif text-xl italic">{WEDDING.hashtag}</div>
          </a>
        </div>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#0A0A0A] text-[#FAFAFA] py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <img
          src="https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/nnvbhv3u_bb644d40-cc12-43ba-9dd5-2e6000e1303a.png"
          alt="Carmen & Kerbert monogram"
          className="h-20 sm:h-24 w-auto object-contain"
          style={{ filter: "brightness(0) invert(0.85)" }}
        />
        <div className="font-overline text-[10px] text-white/50">{t("footer.tag")}</div>
        <div className="font-overline text-[10px] text-white/40">{t("footer.made")}</div>
      </div>
    </footer>
  );
};
